const theme = {
  colors: {
    primary: '#FFDE59', // Yellow
    secondary: 'black', // Black
    background: '#F5F6F8', // Light Gray
    white: '#FFFFFF', // White
    black: '#262626', // Dark Gray
    text: '#333333', // Dark Gray
    heading: '#000000', // Black
    error: '#E74C3C', // Red
    success: '#2ECC71', // Green
    border: '#ddd', // Light Gray
  },
  breakpoints: {
    mobile: '320px',
    tablet: '768px',
    desktop: '1024px',
  },
  spacing: {
    xs: '4px',
    sm: '8px',
    md: '16px',
    lg: '24px',
    xl: '32px',
  }
};

export default theme; 